export enum BookmarksState {
	RETRIEVING = 'RETRIEVING',
	IS_NATIVE = 'IS_NATIVE',
	PLUGIN_NOT_INSTALLED = 'PLUGIN_NOT_INSTALLED',
	SHOWING_BOOKMARKS = 'SHOWING_BOOKMARKS',
	EMPTY = 'EMPTY',
}

export enum BookmarkSelectState {
	SELECTED = 'SELECTED',
	UNSELECTED = 'UNSELECTED',
	SOME_SELECTED = 'SOME_SELECTED',
}

export interface BookmarkItem {
	id: string;
	folder: boolean;
	name: string;
	url: string;
	selected: BookmarkSelectState;
	collapsed: boolean;
	children: BookmarkItem[];

	parent?: BookmarkItem;
}
